import React, { useEffect, useState } from 'react';
import {
  Navbar,
  NavbarBrand,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import axios from 'axios';
import { isEmpty } from 'lodash';
import Logo from '../components/Logo';

const Header = () => {
  
  return (
    <>
      {/* <Navbar color='white' light className='py-1 app-header'>
        <div className='d-flex align-items-center'>
          <NavbarBrand href='/' className='me-0'>
            <Logo height={50} />
          </NavbarBrand>

          <h6 className='ps-3 text-primary d-inline mx-1 mt-1 mb-0 f-28 raleway-500'>
      <span className="mx-1">|</span>
     PBM Network Website
      </h6>
          <h6 className='ps-3 text-primary d-inline mx-1 mt-1 mb-0 f-28'>
           
          </h6>
        </div>
        <div className='ms-auto powered-by'>
          <img src={""}/>
        </div>
      </Navbar>
    </> */}

    
      <Navbar color="white" light className="py-1 app-header">
        <div className="d-flex align-items-center">
          <NavbarBrand href="/" className="me-0">
            <Logo height={50} />
          </NavbarBrand>
          <h6 className="ps-3 ms-3 text-primary d-inline mx-1 mt-1 mb-0 top_hed">
          PBM Network Website
          </h6>
        </div>
        <div
          //onLoad={() => fetchNotificationsCount()}
          className="ms-auto powered-by"
        >
        
        </div>
        </Navbar>
        </>
  );
};

export default Header;
